import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTellentLogoComponent } from '../../components/email-tellent-logo/email-tellent-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { TellentProductsFooterComponent } from '../../components/tellent-products-footer/tellent-products-footer.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  styleUrls: ['../../global-styles.less', './tellent-account-activation.component.less'],
  templateUrl: './tellent-account-activation.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailTellentLogoComponent,
    TellentProductsFooterComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class TellentAccountActivationTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<TellentAccountActivationTemplateData>;
}

export type TellentAccountActivationTemplateData = {
  header: string;
  subheader: string;
  body: string;
  footer: {
    text: string;
    label: string;
    href: string;
  };
  primary_cta: {
    href: string;
    label: string;
  };
  text: string;
};

export const TellentAccountActivationTemplateMocks: TellentAccountActivationTemplateData[] = [
  {
    header: 'Hello 👋',
    subheader: 'We’ve saved your company account and it’s waiting for you.',
    body: 'Tellent is a leading HR Platform, designed for recruiters and hr managers alike.',
    footer: {
      text: 'Need help?',
      label: 'Contact us',
      href: 'support@tellent.com',
    },
    primary_cta: {
      href: 'https://tellent.com',
      label: 'Claim it now',
    },
    text: "If there's anything we can do to help, reply to this email and let us know.",
  },
];
